module.exports = __webpack_public_path__ + "static/img/DIYStep5.e493a76a.jpg";